import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { FuseFullscreenModule } from '@fuse/components/fullscreen';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { AlertsModule } from 'app/layout/common/alerts/alerts.module';
import { LanguagesModule } from 'app/layout/common/languages/languages.module';
import { NotificationsModule } from 'app/layout/common/notifications/notifications.module';
import { SettingsModule } from 'app/layout/common/settings/settings.module';
import { UserModule } from 'app/layout/common/user/user.module';
import { ClassicLayoutComponent } from 'app/layout/layouts/classic/classic.component';

@NgModule({
  declarations: [ClassicLayoutComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    FuseFullscreenModule,
    FuseNavigationModule,
    LanguagesModule,
    NotificationsModule,
    UserModule,
    SettingsModule,
    AlertsModule,
    LanguagesModule,
  ],
  exports: [ClassicLayoutComponent],
})
export class ClassicLayoutModule {}
